export const whiteListParams = ["gclid", "utm_id", "utm_source"]
